import { ExtBase, ClientImage, Base } from "../../../../core/db/models/index";
import { Order, OfflineMixin } from "./order";
import { OrderItemLike } from "./orderItem";


export interface LegacyModelMixin
{
    is_legacy: boolean;
}

export interface CleansingType extends ExtBase, LegacyModelMixin
{
    name: string;
    description: string;
}

export interface MeasuringTypeLike extends ExtBase, LegacyModelMixin
{
    name: string;
    description: string;
    unit: string;
    amount: string;
    optionality: string;
    group: string;
}

export class MeasuringType implements Partial<MeasuringTypeLike>
{
    public static readonly AMOUNT_ONE = 'one';
    public static readonly AMOUNT_MULTIPLE = 'multiple';
    public static readonly OPTIONALITY_OPTIONAL = 'optional';
    public static readonly OPTIONALITY_REQUIRED = 'required';
}

export interface Reason extends ExtBase
{
    name: string;
    description: string;
}

export interface Facility extends ExtBase
{
    name: string;
    description: string;
}

export interface OrderImage extends ClientImage, OfflineMixin
{
    order_id: number;
    order?: Order;
}
